import VSelectCourseCover from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCourseCover', VSelectCourseCover),
};
